
























import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'Scale'
})

export default class scale extends Vue {
  @Prop({
    default: 0,
    type: Number
  }) activeIndex!: number

  timer = 0
  once = 0

  mounted () {
    this.$nextTick(() => {
      console.log(this.activeIndex, 1324)
      this.openTimer()
    })
  }

  // 第三屏鼠标移出事件
  // mouseOver () {
  //   this.once = 0
  //   clearInterval(this.timer)
  // }

  // 鼠标移入
  // mouseLeave () {
  //   this.openTimer()
  // }

  // 第三屏，每隔2秒切换动画
  openTimer () {
    // if (this.activeIndex !== 2) {
    //   this.once = 0
    //   clearInterval(this.timer)
    //   return
    // }
    this.timer = setInterval(() => {
      this.once++
      if (this.once > 3) {
        this.once = 1
      }
      console.log(this.once, '手机')
    }, 2000)
  }
}
